import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import Link from 'components/Links'

import { ParagraphSmallCaps, Paragraph1 } from 'components/Paragraphs'

import Triangle from 'components/ui/icons/Triangle'

const Container = styled.div(({ theme }) => css`
  background: ${theme.blueDark};
  display: flex;
  padding: 0 20px;
  height: 90px;
  align-items: center;
`)

const Step = styled.div`
  
`

const Label = styled(ParagraphSmallCaps)`
  opacity: ${({ theme }) => theme.opacity};
  margin-bottom: 5px;
`

const Tag = styled(Paragraph1)(({ theme, isCurrent }) => css`
  background: ${isCurrent ? theme.tonic : theme.blueElectric};
  color: ${isCurrent ? theme.blueUltraDark : theme.white};
  padding: 0 5px;
  height: 25px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  white-space: nowrap;
  :hover {
    opacity: 0.5;
  }
`)

const TriangleStyled = styled(Triangle)(({ theme }) => css`
  margin: 0 10px;
  fill: ${theme.white};
  transform: rotate(-90deg);
`)

const LinkStyled = styled(Link)`
  display: flex;
  align-items: center;
`

const truncateLabel = (input) => input.length > 25 ? `${input.substring(0, 25)}...` : input

const BreadCrumb = ({ currentNode }) => {
  const breadcrumb = [...currentNode.ancestors()].reverse()
  return (
    <Container>
      {
        breadcrumb.map(d => {
          const isCurrent = d.data.id === currentNode.data.id
          const shortLabel = truncateLabel(d.data.label)
          return (
            <Step key={d.data.id}>
              <Label>
                {d.data.nature}
              </Label>
              <LinkStyled to={`/${d.data.id}`} title={d.data.label}>
                <Tag isCurrent={isCurrent}>
                  {shortLabel}
                </Tag>
                {
                  !isCurrent && <TriangleStyled />
                }
              </LinkStyled>
            </Step>
          )
        })
      }
    </Container>

  )
}

export default BreadCrumb
